import { BaseMeasures } from './BaseMeasures';

export const ExperienceActionMeasures = new BaseMeasures();
